// =====================================================
// FILL SERVICES DROPDOWNS FROM DPO CHECKBOXES
// =====================================================

(function() {
    // Function to extract and populate DPO options
    function populateDPOOptions() {
        //const selectElement = document.getElementById('bundle-services-{{ bundle_product_handle }}');
        const selectElement = document.querySelector('.bundle-services-select');
        const dpoContainer = document.querySelector('.dpo-container #itoris_dynamicproductoptions');
        
        if (!selectElement || !dpoContainer) return;

        const checkboxOptions = dpoContainer.querySelectorAll('.field.choice.admin__field.admin__field-option');
        
        if (checkboxOptions.length === 0) return;

        // Clear existing options except the first placeholder
        while (selectElement.options.length > 1) {
        selectElement.remove(1);
        }

        // Extract and add each option
        checkboxOptions.forEach((optionDiv) => {
        const checkbox = optionDiv.querySelector('input[type="checkbox"]');
        const label = optionDiv.querySelector('label.label');
        
        if (!checkbox || !label) return;

        // Get option value (from checkbox value attribute)
        const optionValue = checkbox.value;
        
        // Get option title (from label span)
        const titleSpan = label.querySelector('span:not(.price-notice):not(.dpo_tooltip_icon)');
        const optionTitle = titleSpan ? titleSpan.textContent.trim() : '';
        
        // Get price if available
        const priceNotice = label.querySelector('.price-notice');
        const priceText = priceNotice ? ' ' + priceNotice.textContent.trim() : '';
        
        // Get the product SKU - this is the Shopify variant ID we need
        const productSku = checkbox.getAttribute('product-sku') || '';
        
        // Create option element
        const option = document.createElement('option');
        option.value = productSku; // Use product SKU directly as the variant ID
        option.textContent = optionTitle + priceText;
        option.setAttribute('data-price', checkbox.getAttribute('price') || '0');
        option.setAttribute('data-dpo-value', optionValue);
        
        selectElement.appendChild(option);
        });
    }

    // Try to populate immediately
    populateDPOOptions();

    // Also listen for DPO loading completion
    window.addEventListener('dpo_loading_finished', function() {
        populateDPOOptions();
    });

    // Fallback: Use MutationObserver to detect when DPO container is added/modified
    const observer = new MutationObserver(function(mutations) {
        if (document.querySelector('.dpo-container #itoris_dynamicproductoptions .field.choice')) {
        populateDPOOptions();
        observer.disconnect(); // Stop observing once we've populated
        }
    });

    // Start observing the document for DPO container
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Timeout fallback (stop observing after 5 seconds)
    setTimeout(function() {
        observer.disconnect();
    }, 5000);   
})();

// =====================================================
// BUNDLE CONFIGURATION
// =====================================================
const BUNDLE_CONFIG = {
    // Set to false to disable all bundle-related console logs in production
    enableLogging: true,

    // Helper function for conditional logging
    log: function (...args) {
        if (this.enableLogging) {
            console.log(...args);
        }
    },
    warn: function (...args) {
        if (this.enableLogging) {
            console.warn(...args);
        }
    },
    error: function (...args) {
        // Always log errors, even in production
        console.error(...args);
    },
};

// Add bundle to cart functionality
document.addEventListener('DOMContentLoaded', function () {
    // Main bundle button functionality
    const addBundleButton = document.getElementById('add-bundle-to-cart');

    if (addBundleButton) {
        // Check if we have a specific bundle assigned
        const bundleId = addBundleButton.getAttribute('data-bundle-id');
        const bundleHandle = addBundleButton.getAttribute('data-bundle-handle');

        // Log bundle info if available
        if (bundleId && bundleHandle) {
            BUNDLE_CONFIG.log(`Using specific bundle: ${bundleHandle} (ID: ${bundleId})`);
        }

        addBundleButton.addEventListener('click', function (e) {
            e.preventDefault();

            // Save original button text
            const originalText = this.querySelector('.btn__text').textContent;

            // Change the button text to show it's working
            this.querySelector('.btn__text').textContent = 'Adding...';
            this.disabled = true;

            const forms = document.querySelectorAll('#product-bundle-container .bundle-form');
            const requests = [];

            // Add bundle info to the request if available
            if (bundleId) {
                // You can add bundle information to the cart as a property
                const bundleProperty = {
                    _bundle_id: bundleId,
                    _bundle_handle: bundleHandle,
                };

                BUNDLE_CONFIG.log('Adding bundle properties:', bundleProperty);
            }

            forms.forEach(form => {
                const formData = new FormData(form);

                // Add bundle info to each item if available
                if (bundleId) {
                    formData.append('properties[_bundle_id]', bundleId);
                    formData.append('properties[_bundle_handle]', bundleHandle);
                }

                const request = fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData,
                });
                requests.push(request);
            });

            // Promise.all waits for all the fetch requests to finish
            Promise.all(requests)
                .then(responses => {
                    // Check if all responses are OK
                    const allSuccessful = responses.every(response => response.ok);

                    if (allSuccessful) {
                        BUNDLE_CONFIG.log('All products added!');

                        // Show success message
                        const successMessage = document.createElement('div');
                        successMessage.className = 'bundle-success-message';
                        successMessage.innerHTML = '<span>✓ Bundle added to cart!</span>';
                        addBundleButton.parentNode.insertBefore(
                            successMessage,
                            addBundleButton.nextSibling
                        );

                        // Fade out the message after 3 seconds
                        setTimeout(() => {
                            successMessage.style.opacity = '0';
                            setTimeout(() => {
                                successMessage.remove();
                            }, 500);
                        }, 3000);

                        // Now, you can either redirect to the cart or open your cart drawer
                        // Option A: Redirect to cart
                        window.location.href = '/cart';

                        // Option B: Open cart drawer (if your theme has one)
                        // document.dispatchEvent(new CustomEvent('cart:open'));
                    } else {
                        throw new Error('One or more products failed to add to cart');
                    }
                })
                .catch(error => {
                    BUNDLE_CONFIG.error('Error:', error);
                    // Re-enable the button and show an error message
                    this.querySelector('.btn__text').textContent = originalText;
                    this.disabled = false;

                    // Show error message
                    const errorMessage = document.createElement('div');
                    errorMessage.className = 'bundle-error-message';
                    errorMessage.innerHTML =
                        '<span>Failed to add bundle to cart. Please try again.</span>';
                    addBundleButton.parentNode.insertBefore(
                        errorMessage,
                        addBundleButton.nextSibling
                    );

                    // Fade out the message after 3 seconds
                    setTimeout(() => {
                        errorMessage.style.opacity = '0';
                        setTimeout(() => {
                            errorMessage.remove();
                        }, 500);
                    }, 3000);
                });
        });
    }

    // Individual bundle buttons functionality
    const addIndividualBundleButtons = document.querySelectorAll('.btn--add-individual-bundle');

    if (addIndividualBundleButtons.length > 0) {
        addIndividualBundleButtons.forEach(button => {
            button.addEventListener('click', async function (e) {
                e.preventDefault();

                // Don't proceed if button is disabled
                if (this.disabled || this.classList.contains('btn--disabled')) {
                    BUNDLE_CONFIG.warn(
                        '⚠️ Bundle button is disabled - products may be out of stock'
                    );
                    return;
                }

                // Get data attributes
                const bundleProductHandle = this.getAttribute('data-bundle-product');
                const mainProductId = this.getAttribute('data-main-product');
                const bundleVariantId = this.getAttribute('data-bundle-variant-id');

                BUNDLE_CONFIG.log('🔍 Button data attributes:', {
                    bundleProductHandle,
                    mainProductId,
                    bundleVariantId,
                });

                // Save original button text
                const originalText = this.querySelector('.btn__text').textContent;
                const originalButton = this;

                // Change the button text to show it's working
                this.querySelector('.btn__text').textContent = 'Adding...';
                this.disabled = true;

                // Get the variant ID of the current product (assuming it's already in the page)
                const currentProductVariantId =
                    document.querySelector('input[name="id"]')?.value;

                if (!currentProductVariantId) {
                    BUNDLE_CONFIG.error('❌ Could not find current product variant ID');
                    this.querySelector('.btn__text').textContent = originalText;
                    this.disabled = false;
                    alert('Error: Could not find product variant ID. Please refresh the page.');
                    return;
                }

                if (!bundleVariantId) {
                    BUNDLE_CONFIG.error('❌ Bundle variant ID is missing');
                    this.querySelector('.btn__text').textContent = originalText;
                    this.disabled = false;
                    alert('Error: Bundle product information is missing.');
                    return;
                }

                // Extract the numeric variant ID from the Shopify GID format
                const bundleVariantIdClean = bundleVariantId.split('/').pop();

                BUNDLE_CONFIG.log('📦 Variant IDs:', {
                    currentProductVariantId,
                    bundleVariantIdRaw: bundleVariantId,
                    bundleVariantIdExtracted: bundleVariantIdClean,
                });

                // Find the service select element for this specific bundle
                const buttonContainer = this.closest('.individual-bundle-item');
                const serviceSelect = buttonContainer?.querySelector('.bundle-services-select');
                const selectedServiceValue = serviceSelect?.value;

                try {
                    // Check if DPO is available and if a service is selected
                    if (
                        serviceSelect &&
                        selectedServiceValue &&
                        selectedServiceValue !== '' &&
                        window.dpoOptions
                    ) {
                        BUNDLE_CONFIG.log(
                            '🔧 DPO detected - Using DPO workflow for service options'
                        );

                        // Get the DPO value from the selected option
                        const selectedOption =
                            serviceSelect.options[serviceSelect.selectedIndex];
                        const dpoValue = selectedOption.getAttribute('data-dpo-value');
                        const serviceTitle = selectedOption.textContent;

                        BUNDLE_CONFIG.log('🔍 Selected service:', {
                            shopifyVariantId: selectedServiceValue,
                            dpoValue: dpoValue,
                            title: serviceTitle,
                        });

                        if (dpoValue) {
                            // Find and check the corresponding DPO checkbox
                            const dpoCheckbox = document.querySelector(
                                `input[type="checkbox"][value="${dpoValue}"]`
                            );

                            if (dpoCheckbox && !dpoCheckbox.disabled) {
                                BUNDLE_CONFIG.log('✓ Found DPO checkbox, checking it...');

                                // Uncheck all other checkboxes in the same group first
                                const allCheckboxes = document.querySelectorAll(
                                    `input[type="checkbox"][name="${dpoCheckbox.name}"]`
                                );
                                allCheckboxes.forEach(cb => {
                                    if (cb !== dpoCheckbox) cb.checked = false;
                                });

                                // Check the selected checkbox
                                dpoCheckbox.checked = true;

                                // Trigger change event so DPO updates its internal state
                                dpoCheckbox.dispatchEvent(
                                    new Event('change', { bubbles: true })
                                );

                                // Wait for DPO to process
                                await new Promise(resolve => setTimeout(resolve, 300));

                                BUNDLE_CONFIG.log('🔍 DPO state after checkbox selection:');
                                BUNDLE_CONFIG.log('  - Checkbox checked:', dpoCheckbox.checked);
                                BUNDLE_CONFIG.log('  - DPO options object:', window.dpoOptions);

                                // Validate DPO form
                                if (window.dpoOptions.validateForm()) {
                                    BUNDLE_CONFIG.log('✓ DPO validation passed');

                                    // Check DPO's add to cart method
                                    BUNDLE_CONFIG.log('🔍 DPO Configuration:', {
                                        directAddToCartSubmit:
                                            window.dpoObserver?.directAddToCartSubmit,
                                        priceHandler: window.dpoObserver?.priceHandler,
                                        checkoutMethod: window.dpoObserver?.checkoutMethod,
                                    });

                                    // Store the bundle info temporarily
                                    window._bundleInfo = {
                                        bundleVariantId: bundleVariantIdClean,
                                        bundleProductHandle: bundleProductHandle,
                                        addBundleProduct: true,
                                    };

                                    // SIMPLE APPROACH: Add bundle product BEFORE triggering DPO
                                    // This ensures it's done before any redirect can happen
                                    BUNDLE_CONFIG.log(
                                        '📦 PRE-ADDING bundle product before DPO flow starts...'
                                    );

                                    // Add the bundle product first, synchronously
                                    fetch('/cart/add.js', {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({
                                            id: bundleVariantIdClean,
                                            quantity: 1,
                                            properties: {
                                                _bundle_product: bundleProductHandle,
                                                _bundle_type: 'complementary',
                                            },
                                        }),
                                    })
                                        .then(async bundleResponse => {
                                            if (bundleResponse.ok) {
                                                const bundleData = await bundleResponse.json();
                                                BUNDLE_CONFIG.log(
                                                    '✓ Bundle product PRE-ADDED successfully:',
                                                    bundleData
                                                );

                                                // Mark as completed
                                                window._bundleInfo.addBundleProduct = false;

                                                // NOW trigger DPO's add to cart
                                                BUNDLE_CONFIG.log(
                                                    '🚀 Now triggering DPO add to cart...'
                                                );
                                                window.dpoOptions.validateVariantConfig();
                                            } else {
                                                const errorData = await bundleResponse.json();
                                                BUNDLE_CONFIG.error(
                                                    '❌ Failed to PRE-ADD bundle product:',
                                                    errorData
                                                );

                                                // Still trigger DPO even if bundle fails
                                                window.dpoOptions.validateVariantConfig();
                                            }
                                        })
                                        .catch(error => {
                                            BUNDLE_CONFIG.error(
                                                '❌ Error PRE-ADDING bundle product:',
                                                error
                                            );

                                            // Still trigger DPO even if bundle fails
                                            window.dpoOptions.validateVariantConfig();
                                        });

                                    // Don't call validateVariantConfig here - it's called in the promise chain above
                                    // DPO will handle the redirect to cart
                                    return;
                                } else {
                                    BUNDLE_CONFIG.error('❌ DPO validation failed');
                                    throw new Error(
                                        'Product configuration validation failed. Please check your selections.'
                                    );
                                }
                            } else {
                                BUNDLE_CONFIG.warn(
                                    '⚠️ Could not find or checkbox is disabled for DPO value:',
                                    dpoValue
                                );
                                // Fall through to manual add
                            }
                        } else {
                            BUNDLE_CONFIG.warn('⚠️ No DPO value found on selected option');
                            // Fall through to manual add
                        }
                    }

                    // Fallback: Manual add without DPO (no service selected or DPO not available)
                    BUNDLE_CONFIG.log(
                        '📦 Using manual add to cart (no DPO service or fallback)'
                    );

                    const requests = [];

                    // Add main product
                    requests.push(
                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                id: currentProductVariantId,
                                quantity: 1,
                                properties: {
                                    _bundle_product: bundleProductHandle,
                                    _bundle_type: 'main',
                                },
                            }),
                        })
                    );

                    // Add bundle product
                    requests.push(
                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                id: bundleVariantIdClean,
                                quantity: 1,
                                properties: {
                                    _bundle_product: bundleProductHandle,
                                    _bundle_type: 'complementary',
                                },
                            }),
                        })
                    );

                    // Process the requests
                    const responses = await Promise.all(requests);

                    BUNDLE_CONFIG.log(
                        'Response status codes:',
                        responses.map(r => r.status)
                    );

                    // Parse all responses to get detailed error info
                    const results = await Promise.all(
                        responses.map(async (response, index) => {
                            const data = await response.json().catch(() => ({}));
                            return {
                                index,
                                ok: response.ok,
                                status: response.status,
                                data: data,
                            };
                        })
                    );

                    BUNDLE_CONFIG.log('Detailed results:', results);

                    const allSuccessful = results.every(result => result.ok);

                    if (allSuccessful) {
                        BUNDLE_CONFIG.log('✓ Bundle products added successfully!');
                        BUNDLE_CONFIG.log(
                            'Cart items:',
                            results.map(r => r.data)
                        );

                        // Show success message
                        const successMessage = document.createElement('div');
                        successMessage.className = 'bundle-success-message';
                        successMessage.innerHTML = '<span>✓ Products added to cart!</span>';
                        originalButton.parentNode.insertBefore(
                            successMessage,
                            originalButton.nextSibling
                        );

                        // Fade out the message after 2 seconds
                        setTimeout(() => {
                            successMessage.style.opacity = '0';
                            setTimeout(() => {
                                successMessage.remove();
                            }, 500);
                        }, 2000);

                        // Redirect to cart
                        window.location.href = '/cart';
                    } else {
                        // Log which request failed
                        const failedRequests = results.filter(r => !r.ok);
                        BUNDLE_CONFIG.error('Failed requests:', failedRequests);

                        failedRequests.forEach(result => {
                            BUNDLE_CONFIG.error(`Request ${result.index + 1} failed:`, {
                                status: result.status,
                                error:
                                    result.data.description ||
                                    result.data.message ||
                                    'Unknown error',
                                fullData: result.data,
                            });
                        });

                        throw new Error(
                            `Failed to add ${failedRequests.length} product(s) to cart. Check console for details.`
                        );
                    }
                } catch (error) {
                    BUNDLE_CONFIG.error('❌ Error adding to cart:', error);
                    BUNDLE_CONFIG.error('Error details:', {
                        message: error.message,
                        stack: error.stack,
                    });

                    // Re-enable the button and show an error message
                    originalButton.querySelector('.btn__text').textContent = originalText;
                    originalButton.disabled = false;

                    // Show error message
                    const errorMessage = document.createElement('div');
                    errorMessage.className = 'bundle-error-message';
                    errorMessage.innerHTML = `<span>${
                        error.message || 'Failed to add products to cart. Please try again.'
                    }</span>`;
                    originalButton.parentNode.insertBefore(
                        errorMessage,
                        originalButton.nextSibling
                    );

                    // Fade out the message after 5 seconds
                    setTimeout(() => {
                        errorMessage.style.opacity = '0';
                        setTimeout(() => {
                            errorMessage.remove();
                        }, 500);
                    }, 5000);
                }
            });
        });
    }
});